/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_M_Owners_DescInputs */

const es_nav_m_owners_desc = /** @type {(inputs: Nav_M_Owners_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquila tu barco de Lista 7ª`)
};

const gl_nav_m_owners_desc = /** @type {(inputs: Nav_M_Owners_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aluga o teu barco de Lista 7ª`)
};

const en_nav_m_owners_desc = /** @type {(inputs: Nav_M_Owners_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent out your List 7 boat`)
};

/**
* | output |
* | --- |
* | "Rent out your List 7 boat" |
*
* @param {Nav_M_Owners_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_m_owners_desc = /** @type {((inputs?: Nav_M_Owners_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_M_Owners_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_m_owners_desc(inputs)
	if (locale === "en") return en_nav_m_owners_desc(inputs)
	return es_nav_m_owners_desc(inputs)
});